'use client';

import React from 'react';
import { ExperienceType } from '../types';
import Hotels, { Hotel } from '@/components/packages/Hotels';

interface ExperienceHotelsProps {
  experience: unknown;
  type: ExperienceType;
}

export const ExperienceHotels: React.FC<ExperienceHotelsProps> = ({
  experience,
  type,
}) => {
  if (!experience || type !== 'package') return null;

  const exp = experience as {
    hotels?: Hotel[];
    accommodations?: Hotel[];
  };

  const hotels = exp?.hotels || exp?.accommodations || [];

  if (!Array.isArray(hotels) || hotels.length === 0) return null;

  return <Hotels hotel={hotels} />;
};
